import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import ChatInterface from './components/ChatInterface'
import LoadingScreen from './components/LoadingScreen'
import { ThemeProvider } from './contexts/ThemeContext'
import { ChatProvider } from './contexts/ChatContext'

function App() {
  const { isLoading, isAuthenticated, loginWithRedirect, error } = useAuth0()

  useEffect(() => {
    // If not authenticated and not loading, redirect to login
    if (!isLoading && !isAuthenticated && !error) {
      loginWithRedirect()
    }
  }, [isLoading, isAuthenticated, loginWithRedirect, error])

  // Show loading screen while Auth0 is initializing
  if (isLoading) {
    return <LoadingScreen />
  }

  // Show loading screen if authentication failed or user is not authenticated
  if (!isAuthenticated || error) {
    return <LoadingScreen />
  }

  // User is authenticated, show the app
  return (
    <ThemeProvider>
      <ChatProvider>
        <ChatInterface />
      </ChatProvider>
    </ThemeProvider>
  )
}

export default App
